/* Dahlia Dahlia Multicolour release 20260803-2028 */
(() => {
  'use strict';

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const overlay = document.querySelector('[data-drawer-overlay]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const searchModal = document.querySelector('[data-search-modal]');

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[char]);

  const money = (cents, currency = 'GBP') => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency', currency
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return `£${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  };

  const showOverlay = () => {
    if (!overlay) return;
    overlay.hidden = false;
    document.body.classList.add('drawer-open');
  };

  const hideOverlay = () => {
    if (!overlay) return;
    overlay.hidden = true;
    document.body.classList.remove('drawer-open');
  };

  const closePanels = () => {
    [cartDrawer, mobileMenu].forEach((panel) => {
      if (!panel) return;
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    });
    if (searchModal) {
      searchModal.classList.remove('is-open');
      searchModal.setAttribute('aria-hidden', 'true');
    }
    hideOverlay();
  };

  const openDrawer = (drawer) => {
    if (!drawer) return;
    closePanels();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    showOverlay();
    const closeButton = drawer.querySelector('[data-drawer-close]');
    if (closeButton) closeButton.focus();
  };

  const openSearch = () => {
    if (!searchModal) return;
    closePanels();
    searchModal.classList.add('is-open');
    searchModal.setAttribute('aria-hidden', 'false');
    showOverlay();
    window.setTimeout(() => searchModal.querySelector('[data-search-input]')?.focus(), 150);
  };

  const renderCart = (cart) => {
    const body = document.querySelector('[data-cart-drawer-body]');
    const footer = document.querySelector('[data-cart-drawer-footer]');
    const subtotal = document.querySelector('[data-cart-subtotal]');
    const countNodes = document.querySelectorAll('[data-cart-count]');

    countNodes.forEach((node) => {
      node.textContent = cart.item_count;
      node.hidden = cart.item_count === 0;
    });

    if (!body || !footer) return;
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="drawer-empty"><h2>Your cart is empty</h2><p>Add a few wax melts and come back when your box smells perfect.</p><a class="button" href="' + escapeHtml(root + 'collections/all') + '">Shop wax melts</a></div>';
      footer.hidden = true;
      return;
    }

    body.innerHTML = cart.items.map((item, index) => {
      const image = item.image ? `<a href="${escapeHtml(item.url)}"><img src="${escapeHtml(item.image)}&width=180" alt="${escapeHtml(item.product_title)}" width="82" height="82" loading="lazy"></a>` : '<div></div>';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<span class="drawer-cart-line__variant">${escapeHtml(item.variant_title)}</span>` : '';
      return `<div class="drawer-cart-line">
        ${image}
        <div><a class="drawer-cart-line__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>${variant}
          <div class="drawer-cart-line__controls"><button type="button" data-cart-change="${index + 1}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${index + 1}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button></div>
        </div>
        <span class="drawer-cart-line__price">${money(item.final_line_price, cart.currency)}</span>
      </div>`;
    }).join('');

    footer.hidden = false;
    if (subtotal) subtotal.textContent = money(cart.total_price, cart.currency);
  };

  const fetchCart = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  };

  const refreshCart = async (openAfter = false) => {
    try {
      const cart = await fetchCart();
      renderCart(cart);
      if (openAfter) openDrawer(cartDrawer);
    } catch (error) {
      const body = document.querySelector('[data-cart-drawer-body]');
      if (body) body.innerHTML = '<p class="cart-drawer__loading">We could not load your cart. Please open the cart page instead.</p>';
    }
  };

  const changeCartLine = async (line, quantity) => {
    const response = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    });
    if (!response.ok) throw new Error('Unable to update cart');
    renderCart(await response.json());
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-mobile-menu-open]')) openDrawer(mobileMenu);

    if (event.target.closest('[data-cart-open]')) {
      openDrawer(cartDrawer);
      refreshCart(false);
    }

    if (event.target.closest('[data-mobile-search-focus]')) {
      const mobileSearchInput = document.querySelector(
        '.mobile-header-search input[name="q"]'
      );

      if (mobileSearchInput) {
        mobileSearchInput.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        window.setTimeout(() => {
          mobileSearchInput.focus();
        }, 250);
      }
    }

    if (event.target.closest('[data-search-open]')) openSearch();
    if (event.target.closest('[data-search-close], [data-drawer-close]') || event.target === overlay) closePanels();

    const changeButton = event.target.closest('[data-cart-change]');
    if (changeButton) {
      changeButton.disabled = true;
      changeCartLine(changeButton.dataset.cartChange, changeButton.dataset.quantity).catch(() => {
        changeButton.disabled = false;
      });
    }

    const minus = event.target.closest('[data-quantity-minus]');
    const plus = event.target.closest('[data-quantity-plus]');
    if (minus || plus) {
      const wrapper = event.target.closest('.quantity-selector');
      const input = wrapper?.querySelector('input[type="number"]');
      if (!input) return;
      const next = Math.max(Number(input.min) || 1, Number(input.value || 1) + (plus ? 1 : -1));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePanels();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-ajax-cart], form[data-type="add-to-cart-form"]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const original = button?.textContent;
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) {
        const detail = await response.json().catch(() => ({}));
        throw new Error(detail.description || 'Unable to add this item');
      }
      await refreshCart(true);
    } catch (error) {
      window.alert(error.message);
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = original;
      }
    }
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });


  const findGalleryMediaElement = (
    elements,
    mediaId
  ) => Array.from(elements).find(
    (element) => element.dataset.mediaId === String(mediaId)
  );

  const showProductGalleryMedia = (
    gallery,
    mediaId,
    options = {}
  ) => {
    if (!gallery || !mediaId) return false;

    const thumbnail = findGalleryMediaElement(
      gallery.querySelectorAll('[data-product-gallery-thumbnail]'),
      mediaId
    );
    const mobileItem = findGalleryMediaElement(
      gallery.querySelectorAll('[data-product-gallery-mobile-item]'),
      mediaId
    );

    if (!thumbnail && !mobileItem) return false;

    const main = gallery.querySelector('[data-product-gallery-main]');
    const mainImage = main?.querySelector('img');

    if (thumbnail && main && mainImage) {
      const nextSource = thumbnail.dataset.imageSrc;

      if (nextSource) {
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = nextSource;
      }

      mainImage.alt = thumbnail.dataset.imageAlt || '';
      main.dataset.mediaId = String(mediaId);

      gallery
        .querySelectorAll('[data-product-gallery-thumbnail]')
        .forEach((item) => {
          item.setAttribute(
            'aria-current',
            item === thumbnail ? 'true' : 'false'
          );
        });
    }

    if (mobileItem && options.scrollMobile !== false) {
      const mobileTrack = gallery.querySelector(
        '[data-product-gallery-mobile]'
      );

      if (mobileTrack) {
        mobileTrack.scrollTo({
          left: mobileItem.offsetLeft,
          top: 0,
          behavior: options.behavior || 'smooth'
        });
      }
    }

    return true;
  };

  const initialiseProductGalleries = (scope = document) => {
    const galleries = [];

    if (scope.matches?.('[data-product-gallery]')) {
      galleries.push(scope);
    }

    scope.querySelectorAll?.('[data-product-gallery]').forEach(
      (gallery) => galleries.push(gallery)
    );

    galleries.forEach((gallery) => {
      if (gallery.dataset.galleryReady === 'true') return;
      gallery.dataset.galleryReady = 'true';

      const mediaItems = Array.from(
        gallery.querySelectorAll('[data-product-gallery-thumbnail]')
      );
      const desktopQuery = window.matchMedia('(min-width: 990px)');
      const previousButton = gallery.querySelector(
        '[data-product-gallery-previous]'
      );
      const nextButton = gallery.querySelector(
        '[data-product-gallery-next]'
      );
      let autoplayTimer;

      gallery.stopProductGalleryAutoplay = () => {
        gallery.dataset.variantSelectionMade = 'true';
        window.clearInterval(autoplayTimer);
        autoplayTimer = undefined;
      };

      const currentMediaIndex = () => {
        const currentMediaId = gallery.querySelector(
          '[data-product-gallery-main]'
        )?.dataset.mediaId;

        const index = mediaItems.findIndex(
          (item) => item.dataset.mediaId === String(currentMediaId)
        );

        return index >= 0 ? index : 0;
      };

      const showRelativeMedia = (offset) => {
        if (mediaItems.length < 2) return;

        const nextIndex =
          (
            currentMediaIndex()
            + offset
            + mediaItems.length
          ) % mediaItems.length;

        showProductGalleryMedia(
          gallery,
          mediaItems[nextIndex].dataset.mediaId,
          {
            scrollMobile: !desktopQuery.matches,
            behavior: 'smooth'
          }
        );
      };

      const stopAutoplay = () => {
        window.clearInterval(autoplayTimer);
        autoplayTimer = undefined;
      };

      const startAutoplay = () => {
        stopAutoplay();

        if (
          gallery.dataset.variantSelectionMade === 'true'
          || mediaItems.length < 2
          || document.hidden
        ) {
          return;
        }

        autoplayTimer = window.setInterval(() => {
          showRelativeMedia(1);
        }, 3000);
      };

      previousButton?.addEventListener('click', () => {
        showRelativeMedia(-1);
        startAutoplay();
      });

      nextButton?.addEventListener('click', () => {
        showRelativeMedia(1);
        startAutoplay();
      });

      gallery.addEventListener('pointerenter', stopAutoplay);
      gallery.addEventListener('pointerleave', startAutoplay);
      gallery.addEventListener('focusin', stopAutoplay);
      gallery.addEventListener('focusout', (event) => {
        if (!gallery.contains(event.relatedTarget)) {
          startAutoplay();
        }
      });
      gallery.addEventListener('touchstart', stopAutoplay, {
        passive: true
      });
      gallery.addEventListener('touchend', startAutoplay, {
        passive: true
      });

      desktopQuery.addEventListener?.('change', startAutoplay);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });

      const initialMediaId = gallery.dataset.initialMediaId;

      if (initialMediaId) {
        window.requestAnimationFrame(() => {
          showProductGalleryMedia(
            gallery,
            initialMediaId,
            {
              behavior: 'auto',
              scrollMobile: false
            }
          );
          startAutoplay();
        });
      } else {
        startAutoplay();
      }
    });
  };

  initialiseProductGalleries();

  document.querySelectorAll('[data-variant-radio]').forEach((radio) => {
    radio.addEventListener('change', () => {
      if (!radio.checked) return;
      const section = radio.closest('[data-product-section]');
      const gallery = section?.querySelector(
        '[data-product-gallery]'
      );

      gallery?.stopProductGalleryAutoplay?.();

      const addButton = section?.querySelector('[data-add-to-cart]');
      const priceWrap = section?.querySelector('[data-product-price]');
      const price = priceWrap?.querySelector('.price-current');
      const comparePrice = priceWrap?.querySelector('[data-product-compare-price]');
      const available = radio.dataset.available === 'true';
      if (price && radio.dataset.price) price.textContent = radio.dataset.price;
      if (comparePrice) {
        const hasSalePrice = Number(radio.dataset.compareValue || 0) > Number(radio.dataset.priceValue || 0);
        comparePrice.textContent = radio.dataset.compare || '';
        comparePrice.classList.toggle('is-hidden', !hasSalePrice);
        priceWrap?.classList.toggle('price--sale', hasSalePrice);
      }
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? 'Add to cart' : 'Sold out';
      }
      if (radio.dataset.mediaId) {
        showProductGalleryMedia(
          gallery,
          radio.dataset.mediaId
        );
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', radio.value);
      window.history.replaceState({}, '', url);
    });
  });


  const initialiseMobileAnnouncements = (scope = document) => {
    const announcementBars = [];

    if (scope.matches?.('[data-mobile-announcement]')) {
      announcementBars.push(scope);
    }

    scope.querySelectorAll?.('[data-mobile-announcement]').forEach((bar) => {
      announcementBars.push(bar);
    });

    announcementBars.forEach((bar) => {
      if (bar.dataset.mobileAnnouncementReady === 'true') return;

      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const allPanels = Array.from(
        bar.querySelectorAll('[data-mobile-announcement-panel]')
      );
      const enabledPanels = allPanels.filter(
        (panel) => panel.dataset.mobileEnabled === 'true'
      );
      const rotationEnabled =
        bar.dataset.mobileRotationEnabled === 'true';
      const rotationSpeed = Math.max(
        1000,
        Number(bar.dataset.mobileRotationSpeed) || 5000
      );

      let currentIndex = 0;
      let rotationTimer;

      const stopRotation = () => {
        window.clearInterval(rotationTimer);
        rotationTimer = undefined;
      };

      const showPanel = (index) => {
        if (!mobileQuery.matches) {
          allPanels.forEach((panel) => {
            panel.classList.remove('is-active-mobile');
            panel.removeAttribute('aria-hidden');
          });
          return;
        }

        if (!enabledPanels.length) return;

        currentIndex =
          (index + enabledPanels.length) % enabledPanels.length;

        allPanels.forEach((panel) => {
          const isActive = panel === enabledPanels[currentIndex];
          panel.classList.toggle('is-active-mobile', isActive);
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      };

      const startRotation = () => {
        stopRotation();

        if (
          !mobileQuery.matches
          || !rotationEnabled
          || enabledPanels.length < 2
          || document.hidden
        ) {
          return;
        }

        rotationTimer = window.setInterval(() => {
          showPanel(currentIndex + 1);
        }, rotationSpeed);
      };

      const refreshMode = () => {
        stopRotation();

        if (mobileQuery.matches) {
          showPanel(currentIndex);
          startRotation();
        } else {
          showPanel(currentIndex);
        }
      };

      mobileQuery.addEventListener?.('change', refreshMode);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopRotation();
        } else {
          startRotation();
        }
      });

      refreshMode();
      bar.dataset.mobileAnnouncementReady = 'true';
    });
  };

  initialiseMobileAnnouncements();
  document.addEventListener('shopify:section:load', (event) => {
    initialiseMobileAnnouncements(event.target);
  });

  const normaliseClpLineBreaks = (scope = document) => {
    scope.querySelectorAll('.clp-information__text .metafield-rich_text_field').forEach((root) => {
      root.querySelectorAll('.clp-flow-item--bracket-lead').forEach((item) => {
        item.classList.remove('clp-flow-item--bracket-lead');
      });

      const topLevelItems = Array.from(root.children).filter((item) => item.textContent.trim());
      const firstItem = topLevelItems[0];
      const firstItemIsBracketed = firstItem
        && /^\([^\r\n]+\)$/.test(firstItem.textContent.trim());

      if (firstItemIsBracketed && topLevelItems.length > 1) {
        firstItem.classList.add('clp-flow-item--bracket-lead');
      }

      const breaks = Array.from(root.querySelectorAll('br'));
      let permittedBreak = null;

      if (breaks.length) {
        const firstBreak = breaks[0];
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_ALL);
        let textBeforeBreak = '';
        let current;

        while ((current = walker.nextNode())) {
          if (current === firstBreak) break;
          if (current.nodeType === Node.TEXT_NODE) {
            textBeforeBreak += current.nodeValue || '';
          }
        }

        if (/^\([^\r\n]+\)$/.test(textBeforeBreak.trim())) {
          permittedBreak = firstBreak;
          permittedBreak.classList.add('clp-permitted-line-break');
        }
      }

      breaks.forEach((lineBreak) => {
        if (lineBreak === permittedBreak) return;
        lineBreak.replaceWith(document.createTextNode(' '));
      });
    });
  };

  const boldClpSignalWord = (scope = document) => {
    scope.querySelectorAll('.clp-information__text').forEach((container) => {
      if (container.dataset.clpSignalFormatted === 'true') return;

      const walker = document.createTreeWalker(
        container,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            return node.nodeValue && node.nodeValue.trim()
              ? NodeFilter.FILTER_ACCEPT
              : NodeFilter.FILTER_SKIP;
          }
        }
      );

      let textNode = walker.nextNode();
      if (!textNode) return;

      if (/^\([^\r\n]+\)$/.test(textNode.nodeValue.trim())) {
        textNode = walker.nextNode();
        if (!textNode) {
          container.dataset.clpSignalFormatted = 'true';
          return;
        }
      }

      if (textNode.parentElement?.closest('strong, b')) {
        container.dataset.clpSignalFormatted = 'true';
        return;
      }

      const match = textNode.nodeValue.match(/^(\s*)(warning|danger)(\s*:)?/i);
      if (!match) {
        container.dataset.clpSignalFormatted = 'true';
        return;
      }

      const fragment = document.createDocumentFragment();
      if (match[1]) fragment.append(document.createTextNode(match[1]));

      const strong = document.createElement('strong');
      strong.textContent = `${match[2]}${match[3] || ''}`;
      fragment.append(strong);

      const remainingText = textNode.nodeValue.slice(match[0].length);
      if (remainingText) fragment.append(document.createTextNode(remainingText));

      textNode.replaceWith(fragment);
      container.dataset.clpSignalFormatted = 'true';
    });
  };

  const protectClpCompoundNames = (scope = document) => {
    scope.querySelectorAll('.clp-information__text').forEach((container) => {
      const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
      let node;

      while ((node = walker.nextNode())) {
        const characters = Array.from(node.nodeValue || '');
        let changed = false;

        for (let index = 1; index < characters.length - 1; index += 1) {
          if (characters[index] !== '-') continue;

          const before = characters[index - 1];
          const after = characters[index + 1];
          const isLetterOrNumber = (value) => /[A-Za-z0-9]/.test(value);

          if (isLetterOrNumber(before) && isLetterOrNumber(after)) {
            characters[index] = '\u2011';
            changed = true;
          }
        }

        if (changed) node.nodeValue = characters.join('');
      }
    });
  };

  const formatClpInformation = (scope = document) => {
    normaliseClpLineBreaks(scope);
    boldClpSignalWord(scope);
    protectClpCompoundNames(scope);
  };

  formatClpInformation();
  document.addEventListener('shopify:section:load', (event) => formatClpInformation(event.target));



  const initialiseHeroCarousels = (scope = document) => {
    const carousels = [];

    if (scope.matches?.('[data-hero-carousel]')) {
      carousels.push(scope);
    }

    scope.querySelectorAll?.('[data-hero-carousel]').forEach(
      (carousel) => carousels.push(carousel)
    );

    carousels.forEach((carousel) => {
      if (carousel.dataset.heroCarouselReady === 'true') return;

      const slides = Array.from(
        carousel.querySelectorAll('[data-hero-slide]')
      );
      const carouselEnabled =
        carousel.dataset.carouselEnabled === 'true';

      if (!carouselEnabled || slides.length < 2) {
        slides.forEach((slide, index) => {
          const isActive = index === 0;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute(
            'aria-hidden',
            isActive ? 'false' : 'true'
          );
        });

        carousel.dataset.heroCarouselReady = 'true';
        return;
      }

      const previousButton = carousel.querySelector(
        '[data-hero-previous]'
      );
      const nextButton = carousel.querySelector(
        '[data-hero-next]'
      );
      const autoRotate =
        carousel.dataset.autoRotate === 'true';
      const rotationSpeed = Math.max(
        3000,
        Number(carousel.dataset.rotationSpeed) || 3000
      );
      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );
      let currentIndex = Math.max(
        0,
        slides.findIndex(
          (slide) => slide.classList.contains('is-active')
        )
      );
      let rotationTimer;

      const showSlide = (index) => {
        currentIndex =
          (index + slides.length) % slides.length;

        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === currentIndex;

          slide.classList.toggle('is-active', isActive);
          slide.setAttribute(
            'aria-hidden',
            isActive ? 'false' : 'true'
          );
        });
      };

      const stopRotation = () => {
        window.clearInterval(rotationTimer);
        rotationTimer = undefined;
      };

      const startRotation = () => {
        stopRotation();

        if (
          !autoRotate
          || reducedMotion.matches
          || document.hidden
        ) {
          return;
        }

        rotationTimer = window.setInterval(() => {
          showSlide(currentIndex + 1);
        }, rotationSpeed);
      };

      previousButton?.addEventListener('click', () => {
        showSlide(currentIndex - 1);
        startRotation();
      });

      nextButton?.addEventListener('click', () => {
        showSlide(currentIndex + 1);
        startRotation();
      });

      carousel.addEventListener('pointerenter', stopRotation);
      carousel.addEventListener('pointerleave', startRotation);
      carousel.addEventListener('focusin', stopRotation);
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) {
          startRotation();
        }
      });
      carousel.addEventListener('touchstart', stopRotation, {
        passive: true
      });
      carousel.addEventListener('touchend', startRotation, {
        passive: true
      });

      reducedMotion.addEventListener?.('change', startRotation);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopRotation();
        } else {
          startRotation();
        }
      });

      showSlide(currentIndex);
      startRotation();
      carousel.dataset.heroCarouselReady = 'true';
    });
  };

  initialiseHeroCarousels();

  document.addEventListener('shopify:section:load', (event) => {
    initialiseHeroCarousels(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest?.('[data-hero-slide]');
    const carousel = slide?.closest('[data-hero-carousel]');

    if (!slide || !carousel) return;

    const slides = Array.from(
      carousel.querySelectorAll('[data-hero-slide]')
    );
    const selectedIndex = slides.indexOf(slide);

    if (selectedIndex < 0) return;

    slides.forEach((item, index) => {
      const isActive = index === selectedIndex;
      item.classList.toggle('is-active', isActive);
      item.setAttribute(
        'aria-hidden',
        isActive ? 'false' : 'true'
      );
    });
  });

  const initialiseFeaturedCollectionSliders = (scope = document) => {
    const sections = [];

    if (scope.matches?.('.featured-collection')) {
      sections.push(scope);
    }

    scope.querySelectorAll?.('.featured-collection').forEach((section) => {
      sections.push(section);
    });

    sections.forEach((section) => {
      if (section.dataset.productSliderReady === 'true') return;

      const scroller = section.querySelector('[data-product-scroller]');
      const previousButton = section.querySelector('[data-scroller-prev]');
      const nextButton = section.querySelector('[data-scroller-next]');

      if (!scroller) return;

      previousButton?.addEventListener('click', () => {
        scroller.scrollBy({
          left: -Math.max(scroller.clientWidth * 0.82, 280),
          behavior: 'smooth'
        });
      });

      nextButton?.addEventListener('click', () => {
        scroller.scrollBy({
          left: Math.max(scroller.clientWidth * 0.82, 280),
          behavior: 'smooth'
        });
      });

      section.dataset.productSliderReady = 'true';
    });
  };

  initialiseFeaturedCollectionSliders();
  document.addEventListener('shopify:section:load', (event) => {
    initialiseFeaturedCollectionSliders(event.target);
  });

  const initialiseImageCardSliders = (scope = document) => {
    const sections = [];

    if (scope.matches?.('.image-cards-section')) {
      sections.push(scope);
    }

    scope.querySelectorAll?.('.image-cards-section').forEach((section) => {
      sections.push(section);
    });

    sections.forEach((section) => {
      if (section.dataset.imageCardsSliderReady === 'true') return;

      const scroller = section.querySelector('[data-image-cards-scroller]');
      const previousButton = section.querySelector('[data-image-cards-prev]');
      const nextButton = section.querySelector('[data-image-cards-next]');
      const cards = Array.from(scroller?.querySelectorAll('.image-card') || []);

      if (!scroller || cards.length < 2) return;

      const mobileQuery = window.matchMedia('(max-width: 749px)');
      let currentIndex = 0;
      let scrollTimer;
      let autoplayTimer;

      const cardScrollPosition = (card) => {
        return card.offsetLeft - ((scroller.clientWidth - card.offsetWidth) / 2);
      };

      const scrollToCard = (index, behavior = 'smooth') => {
        currentIndex = (index + cards.length) % cards.length;
        scroller.scrollTo({
          left: cardScrollPosition(cards[currentIndex]),
          behavior
        });
      };

      const updateCurrentIndex = () => {
        const viewportCentre = scroller.scrollLeft + (scroller.clientWidth / 2);
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        cards.forEach((card, index) => {
          const cardCentre = card.offsetLeft + (card.offsetWidth / 2);
          const distance = Math.abs(cardCentre - viewportCentre);

          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        currentIndex = nearestIndex;
      };

      const stopAutoplay = () => {
        window.clearInterval(autoplayTimer);
        autoplayTimer = undefined;
      };

      const startAutoplay = () => {
        stopAutoplay();

        if (!mobileQuery.matches || document.hidden) return;

        autoplayTimer = window.setInterval(() => {
          updateCurrentIndex();
          scrollToCard(currentIndex + 1);
        }, 3000);
      };

      scroller.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(updateCurrentIndex, 100);
      }, { passive: true });

      scroller.addEventListener('touchstart', stopAutoplay, { passive: true });
      scroller.addEventListener('touchend', startAutoplay, { passive: true });
      scroller.addEventListener('pointerdown', stopAutoplay);
      scroller.addEventListener('pointerup', startAutoplay);
      scroller.addEventListener('pointercancel', startAutoplay);

      previousButton?.addEventListener('click', () => {
        updateCurrentIndex();
        scrollToCard(currentIndex - 1);
      });

      nextButton?.addEventListener('click', () => {
        updateCurrentIndex();
        scrollToCard(currentIndex + 1);
      });

      mobileQuery.addEventListener?.('change', () => {
        if (mobileQuery.matches) {
          scrollToCard(currentIndex, 'auto');
          startAutoplay();
        } else {
          stopAutoplay();
        }
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });

      if (mobileQuery.matches) {
        window.requestAnimationFrame(() => {
          scrollToCard(0, 'auto');
          startAutoplay();
        });
      }

      section.dataset.imageCardsSliderReady = 'true';
    });
  };

  initialiseImageCardSliders();
  document.addEventListener('shopify:section:load', (event) => {
    initialiseImageCardSliders(event.target);
  });


  const productSearchForms = Array.from(
    document.querySelectorAll('form[data-product-search]')
  );

  const escapeShopifySearchToken = (value = '') => {
    return value
      .replace(/[\\():"]/g, '\\$&')
      .replace(/\*/g, '')
      .trim();
  };

  const searchScopeSource = document.querySelector(
    '[data-site-header][data-search-match-scope]'
  );
  const searchMatchScope =
    searchScopeSource?.dataset.searchMatchScope === 'title_only'
      ? 'title_only'
      : 'title_and_description';

  const buildPrefixProductQuery = (rawTerm) => {
    const terms = rawTerm
      .trim()
      .split(/\s+/)
      .map((term) => escapeShopifySearchToken(term))
      .filter(Boolean);

    return terms
      .map((term) => {
        if (searchMatchScope === 'title_only') {
          return `(title:${term}* OR variants.title:${term}*)`;
        }

        return `(title:${term}* OR body:${term}* OR variants.title:${term}*)`;
      })
      .join(' AND ');
  };

  const extractCustomerSearchTerm = (query = '') => {
    const titleTerms = Array.from(
      query.matchAll(/title:((?:\\.|[^*\s)])+)\*/gi)
    )
      .map((match) => match[1].replace(/\\(.)/g, '$1'))
      .filter(Boolean);

    return titleTerms.length
      ? titleTerms.join(' ')
      : query;
  };

  const currentSearchUrl = new URL(window.location.href);
  const internalSearchQuery =
    currentSearchUrl.searchParams.get('q')
    || '';
  const cleanSearchTerm =
    currentSearchUrl.searchParams.get('term')
    || extractCustomerSearchTerm(internalSearchQuery)
    || '';

  const preserveCustomerTermInSearchLinks = (term) => {
    if (!term) return;

    document.querySelectorAll('a[href]').forEach((link) => {
      const targetUrl = new URL(link.href, window.location.origin);

      if (
        targetUrl.pathname !== currentSearchUrl.pathname
        || !targetUrl.searchParams.has('q')
      ) {
        return;
      }

      targetUrl.searchParams.set('term', term);
      link.href = targetUrl.toString();
    });
  };

  const replaceDisplayedSearchTerm = (term) => {
    if (!term) return;

    document
      .querySelectorAll('form[data-product-search] input[name="q"]')
      .forEach((input) => {
        input.value = term;
      });

    document
      .querySelectorAll('[data-search-display-term]')
      .forEach((element) => {
        element.textContent = term;
      });

    preserveCustomerTermInSearchLinks(term);
  };

  replaceDisplayedSearchTerm(cleanSearchTerm);

  const buildSearchResultsUrl = (rawTerm) => {
    const targetUrl = new URL('/search', window.location.origin);

    targetUrl.searchParams.set(
      'q',
      buildPrefixProductQuery(rawTerm)
    );
    targetUrl.searchParams.set('term', rawTerm);
    targetUrl.searchParams.set('type', 'product');
    targetUrl.searchParams.set(
      'options[unavailable_products]',
      'show'
    );
    targetUrl.searchParams.set('options[prefix]', 'last');
    targetUrl.searchParams.set('sort_by', 'relevance');

    return targetUrl;
  };

  if (
    window.location.pathname.endsWith('/search')
    && internalSearchQuery
    && cleanSearchTerm.trim().length >= 2
  ) {
    const normalisedSearchUrl = buildSearchResultsUrl(
      cleanSearchTerm.trim()
    );
    const requiresNormalisation =
      currentSearchUrl.searchParams.get('q')
        !== normalisedSearchUrl.searchParams.get('q')
      || currentSearchUrl.searchParams.get('term')
        !== normalisedSearchUrl.searchParams.get('term')
      || currentSearchUrl.searchParams.get('type') !== 'product';

    if (requiresNormalisation) {
      window.location.replace(normalisedSearchUrl.toString());
      return;
    }
  }

  productSearchForms.forEach((form) => {
    form.addEventListener('submit', (event) => {
      const queryInput = form.querySelector('input[name="q"]');
      const rawTerm = queryInput?.value.trim();

      if (!rawTerm) return;

      event.preventDefault();
      window.location.assign(
        buildSearchResultsUrl(rawTerm).toString()
      );
    });
  });

  const escapePredictiveHtml = (value = '') => {
    const element = document.createElement('div');
    element.textContent = value;
    return element.innerHTML;
  };

  const formatPredictivePrice = (value) => {
    const rawValue = String(value ?? '').trim();

    if (!rawValue) return '';
    if (rawValue.includes('£')) return rawValue;

    const plainNumber = rawValue.replace(/,/g, '');

    if (/^\d+(?:\.\d+)?$/.test(plainNumber)) {
      const numberValue = Number(plainNumber);

      if (plainNumber.includes('.')) {
        return `£${numberValue.toFixed(2)}`;
      }

      return `£${(numberValue / 100).toFixed(2)}`;
    }

    return `£${rawValue}`;
  };

  const fetchPredictiveProducts = async (
    term,
    limit = 10,
    signal
  ) => {
    const suggestUrl = new URL(
      `${window.Shopify?.routes?.root || '/'}search/suggest.json`,
      window.location.origin
    );

    suggestUrl.searchParams.set('q', term);
    suggestUrl.searchParams.set('resources[type]', 'product');
    suggestUrl.searchParams.set(
      'resources[limit]',
      String(limit)
    );
    suggestUrl.searchParams.set(
      'resources[options][unavailable_products]',
      'show'
    );
    suggestUrl.searchParams.set(
      'resources[options][prefix]',
      'last'
    );
    suggestUrl.searchParams.set(
      'resources[options][fields]',
      searchMatchScope === 'title_only'
        ? 'title,variants.title'
        : 'title,body,variants.title'
    );

    const response = await fetch(suggestUrl.toString(), {
      headers: { Accept: 'application/json' },
      signal
    });

    if (!response.ok) {
      throw new Error('Predictive search failed');
    }

    const payload = await response.json();

    return payload.resources?.results?.products || [];
  };

  const predictiveSearchForms = Array.from(
    document.querySelectorAll('form[data-predictive-search]')
  );

  predictiveSearchForms.forEach((form) => {
    const input = form.querySelector('[data-predictive-search-input]');
    const results = form.querySelector('[data-predictive-search-results]');

    if (!input || !results) return;

    let requestController;
    let requestTimer;

    const closeResults = () => {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    };

    const renderResults = (products, term) => {
      if (!products.length) {
        results.innerHTML = `
          <div class="predictive-search-empty">
            No matching products found
          </div>
        `;
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        return;
      }

      const productItems = products.slice(0, 6).map((product) => {
        const imageUrl =
          product.featured_image?.url
          || product.image
          || '';

        const image = imageUrl
          ? `<img src="${escapePredictiveHtml(imageUrl)}" alt="" loading="lazy">`
          : '';

        const formattedPrice = formatPredictivePrice(product.price);
        const price = formattedPrice
          ? `<span class="predictive-search-item__price">From ${escapePredictiveHtml(formattedPrice)}</span>`
          : '';

        return `
          <li>
            <a class="predictive-search-item" href="${escapePredictiveHtml(product.url)}">
              <span class="predictive-search-item__media">${image}</span>
              <span class="predictive-search-item__content">
                <strong>${escapePredictiveHtml(product.title)}</strong>
                ${price}
              </span>
            </a>
          </li>
        `;
      }).join('');

      results.innerHTML = `
        <div class="predictive-search-results__heading">Products</div>
        <ul role="list">${productItems}</ul>
        <a class="predictive-search-results__all" href="${buildSearchResultsUrl(term).toString()}">
          Show all results for “${escapePredictiveHtml(term)}”
        </a>
      `;

      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const fetchSuggestions = async (term) => {
      requestController?.abort();
      requestController = new AbortController();

      try {
        const products = await fetchPredictiveProducts(
          term,
          6,
          requestController.signal
        );

        renderResults(products, term);
      } catch (error) {
        if (error.name !== 'AbortError') closeResults();
      }
    };

    input.setAttribute('aria-expanded', 'false');

    input.addEventListener('input', () => {
      window.clearTimeout(requestTimer);
      const term = input.value.trim();

      if (term.length < 2) {
        closeResults();
        return;
      }

      requestTimer = window.setTimeout(() => {
        fetchSuggestions(term);
      }, 180);
    });

    input.addEventListener('focus', () => {
      const term = input.value.trim();

      if (term.length >= 2 && !results.innerHTML) {
        fetchSuggestions(term);
      }
    });

    form.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeResults();
    });

    document.addEventListener('click', (event) => {
      if (!form.contains(event.target)) closeResults();
    });
  });

  const renderSearchPageFallback = (products) => {
    const grid = document.querySelector('[data-search-product-grid]');

    if (!grid || !products.length) return;

    grid.innerHTML = products.map((product) => {
      const imageUrl =
        product.featured_image?.url
        || product.image
        || '';

      const image = imageUrl
        ? `<img class="product-card__image" src="${escapePredictiveHtml(imageUrl)}" alt="${escapePredictiveHtml(product.title)}" loading="lazy">`
        : `<div class="product-card__placeholder" aria-hidden="true"><span></span><span></span><span></span><span></span><span></span><span></span></div>`;

      const formattedPrice = formatPredictivePrice(product.price);
      const priceMarkup = formattedPrice
        ? `
          <div class="price">
            <span class="price-prefix">From </span>
            <span class="price-current">${escapePredictiveHtml(formattedPrice)}</span>
          </div>
        `
        : '';

      return `
        <article class="product-card" data-product-card>
          <a class="product-card__media media--square" href="${escapePredictiveHtml(product.url)}">
            ${image}
          </a>
          <div class="product-card__content">
            ${product.vendor
              ? `<p class="product-card__vendor">${escapePredictiveHtml(product.vendor)}</p>`
              : ''}
            <h3 class="product-card__title">
              <a href="${escapePredictiveHtml(product.url)}">${escapePredictiveHtml(product.title)}</a>
            </h3>
            ${priceMarkup}
          </div>
        </article>
      `;
    }).join('');
  };

  const searchPageGrid = document.querySelector(
    '[data-search-product-grid]'
  );

  if (
    window.location.pathname.endsWith('/search')
    && searchPageGrid
    && !searchPageGrid.querySelector('[data-product-card]')
    && cleanSearchTerm.trim().length >= 2
  ) {
    fetchPredictiveProducts(cleanSearchTerm.trim(), 10)
      .then((products) => {
        if (products.length) {
          renderSearchPageFallback(products);
        }
      })
      .catch(() => {
        // Keep Shopify's original empty state if the fallback fails.
      });
  }


  const applyHomepageHeadingColourCycle = () => {
    if (!document.body.classList.contains('template-index')) return;

    const main = document.querySelector('#MainContent') || document.querySelector('main');
    if (!main) return;

    const rootStyles = window.getComputedStyle(document.documentElement);
    const colours = [
      rootStyles.getPropertyValue('--dahlia-announcement-colour-1').trim(),
      rootStyles.getPropertyValue('--dahlia-announcement-colour-2').trim(),
      rootStyles.getPropertyValue('--dahlia-announcement-colour-3').trim()
    ].filter(Boolean);

    if (colours.length !== 3) return;

    const headingPanels = Array.from(
      main.querySelectorAll('.shopify-section .section-heading__panel:not(.section-heading__panel--plain)')
    ).filter((panel) => {
      const sectionElement = panel.closest('section');
      const shopifySection = panel.closest('.shopify-section');
      return !sectionElement?.hidden && !shopifySection?.hidden;
    });

    headingPanels.forEach((panel, index) => {
      const colour = colours[index % colours.length];
      panel.style.setProperty('--heading-panel-color', colour);
      panel.style.setProperty('--heading-panel-bg', colour);
    });
  };

  applyHomepageHeadingColourCycle();

  document.addEventListener('shopify:section:load', () => {
    window.requestAnimationFrame(applyHomepageHeadingColourCycle);
  });

  document.addEventListener('shopify:section:reorder', () => {
    window.requestAnimationFrame(applyHomepageHeadingColourCycle);
  });

  const scrollToTopButton = document.querySelector('[data-scroll-to-top]');

  if (scrollToTopButton) {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let lastScrollPosition = window.scrollY;
    let scrollTicking = false;

    const updateScrollToTopVisibility = () => {
      const currentScrollPosition = window.scrollY;
      const movement = currentScrollPosition - lastScrollPosition;
      const isPastFirstScreen = currentScrollPosition > Math.max(320, window.innerHeight * 0.45);
      const isScrollingUp = movement < -4;
      const shouldShow = isPastFirstScreen && isScrollingUp;

      scrollToTopButton.classList.toggle('is-visible', shouldShow);
      scrollToTopButton.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      lastScrollPosition = currentScrollPosition;
      scrollTicking = false;
    };

    window.addEventListener('scroll', () => {
      if (scrollTicking) return;

      scrollTicking = true;
      window.requestAnimationFrame(updateScrollToTopVisibility);
    }, { passive: true });

    scrollToTopButton.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    });
  }

  refreshCart(false);
})();
